<template>
  <div class="sh-building-signups">
    <div class="sh-gear-scene" aria-hidden="true">
      <i class="fal fa-cog fa-spin sh-gear"></i>
    </div>
    <h2 class="sh-building-title">Yay! Great job building your SignUp!</h2>
    <p class="sh-building-subtitle">Thanks for all you do to bring people together to make a difference.<br> Your SignUp will be ready in just a moment!</p>
  </div>
</template>

<script>
import { mapActions } from "vuex";

// Self-dismissing progress modal shown while rcals mints the repeating
// signup series. Closes itself after DISPLAY_MS and reloads so the new
// occurrences appear. Opened via:
//   setModalProps({ name: 'BuildingSignupsModal', rallyId: <id> })
const DISPLAY_MS = 3000;

export default {
  name: "BuildingSignupsModal",
  mounted() {
    // Not cleared on unmount on purpose: if the user taps the backdrop and
    // closes the modal early, the refresh should still happen so they see
    // the built series rather than a stale list.
    setTimeout(() => {
      this.setModalProps({});
      window.location.reload();
    }, DISPLAY_MS);
  },
  methods: {
    ...mapActions("user", ["setModalProps"]),
  },
};
</script>

<style scoped>
.sh-building-signups {
  padding: 2.5rem 3rem;
  text-align: center;
}

.sh-gear-scene {
  display: inline-block;
}

/* fa-spin's default 2s rotation reads as leisurely; 1.2s feels like work
   is happening without being frantic. */
.sh-gear {
  font-size: 64px;
  color: #1c6b70;
  animation-duration: 1.2s;
}

.sh-building-title {
  margin: 1.25rem 0 0.25rem;
  font-size: 1.25rem;
  color: #1a1a1a;
}

.sh-building-subtitle {
  margin: 0;
  color: #777777;
  font-size: 0.9rem;
}
</style>
